<div class="edituser edituser_tree">
  <div class="UserEdit">

    <!--Search AddOn-->
    <aside _ngcontent-lbe-c19="" class="ng-tns-c19-13 stickySearchIcon">
      <!---->
      <button _ngcontent-lbe-c19="" class="button-color-fix-purple" mat-mini-fab="" (click)="showSearchAddonMethod()">
        @if (showSearchAddon === false) {
          <span class="mat-button-wrapper" style="padding:0px;" title="Search users">
            <mat-icon role="img" style="font-size:20px !important;height:20px !important; width:20px !important"
            aria-hidden="true" data-mat-icon-type="font" class="icon-color-fix">search</mat-icon>
          </span>
        }
        @if (showSearchAddon === true) {
          <span class="mat-button-wrapper" style="padding:0px;">
            <mat-icon role="img" style="font-size: 20px !important; height: 20px !important; width: 20px !important"
            aria-hidden="true" data-mat-icon-type="font" class="icon-color-fix">close</mat-icon>
          </span>
        }
        <span class="mat-button-ripple mat-ripple mat-button-ripple-round"
          matripple="">
        </span>
        <span class="mat-button-focus-overlay"></span>
      </button>
    </aside>
    <div class="stickyTopSrch">
      <div class="panel-body darkBackground_addon" [hidden]="showSearchAddon === false">
        <searchaddon></searchaddon>
      </div>
    </div>

    <!--Not accepted invitation User Warning-->
    @if (userDetails.isPendingAcceptance === null ? false : userDetails.isPendingAcceptance) {
      <div class="panel-body">
        <div class="row heading-background-yellow mt-5">
          <div class="col-lg-12">
            <h4 style="color:black">
              WARNING!
            </h4>
          </div>
        </div>
        <div class="row custom-warn-body">
          <div class="row ">
            <div class="col-lg-11">
              <div class="row ">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                  <svg xmlns="http://www.w3.org/2000/svg" class="pull-right icon icon-tabler icon-tabler-mail-exclamation bounce" width="75" height="75" viewBox="0 0 24 24" stroke-width="1.5" stroke="#ff9300" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M15 19h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5" />
                    <path d="M3 7l9 6l9 -6" />
                    <path d="M19 16v3" />
                    <path d="M19 22v.01" />
                  </svg>
                </div>
                <div class="col-lg-7" style="margin-block: 1.5%;">
                  <h5 style="color:black">User has not accepted the invitation. Click the button to resend the invitation.</h5>
                </div>
              </div>
            </div>
            <div class="col-lg-1" style="margin-top: 2.0%;">
              <button mat-raised-button (click)="handleResendIvite()" type="submit" class="pull-right btn button-fix button-color-fix-red ">
                Resend Invitation
                <mat-icon class=" icon-color-fix">forward_to_inbox</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    }

    <!--User Details-->
    <div class="panel-body row">
      <h4>Update User Details</h4>
    </div>

    @if (userDetails.userPrincipalName==='' && (defaults.componentTool === componentToolEnum.Rulebook && !defaults.isDataAnalytStage() )) {
      <div class="row zoomIn panel-body">
        <div class="form-group col-lg-6 ">
          <div class="blackbg card__desc">
            @for (_ of [].constructor(3); track $index) {
              <div class="card__desc-text-form"></div>
            }
            <div class="card__desc-text"></div>
          </div>
        </div>
        <div class="form-group col-lg-6 ">
          <div class="blackbg card__desc">
            @for (_ of [].constructor(3); track $index) {
              <div class="card__desc-text-form"></div>
            }
            <div class="card__desc-text"></div>
          </div>
        </div>
      </div>
    }
    @if (userDetails.userPrincipalName==='' && (defaults.componentTool === componentToolEnum.Mersy || defaults.isDataAnalytStage()) ) {
      <div class="row zoomIn panel-body">
        <div class="form-group col-lg-6 ">
          <div class="blackbg card__desc">
            @for (_ of [].constructor(2); track $index) {
              <div class="card__desc-text-form"></div>
            }
          </div>
        </div>
        <div class="form-group col-lg-6 ">
          <div class="blackbg card__desc">
            @for (_ of [].constructor(2); track $index) {
              <div class="card__desc-text-form"></div>
            }
          </div>
        </div>
      </div>
    }
    @if (userDetails.userPrincipalName != '') {
      <form [formGroup]="editUserForm" class=" panel-body internalMax zoomIn" autocomplete="off" style="display:contents">
        <div class="stickyTopDetls">
          <div class="form-group col-lg-6 zoomIn">
            @if (!stickyPinned && hasOtherEmails()) {
              <label class="col-lg-4 control-label" for="emailSelect">Username<span class="orange-asterisk"> *</span></label>
            } @else {
              <span class="col-lg-4 control-label static-label">Username</span>
            }
            <div class="col-lg-8 ">
              @if (stickyPinned || !hasOtherEmails()) {
                <p>{{getActiveEmail()}}</p>
              }
              @if (!stickyPinned && hasOtherEmails()) {
                <ng-select labelForId="emailSelect"
                  [items]="userDetails.otherEmails"
                  [searchable]="true"
                  [clearable]="false"
                  class="tenantStyling required"
                  formControlName="email"
                  [dropdownPosition]="'bottom'"
                  required>
                </ng-select>
              }
            </div>
          </div>
          <div class="form-group col-lg-6 zoomIn">
            @if (!stickyPinned) {
              <label class="col-lg-4 control-label" for="displayName">Display Name<span class="orange-asterisk"> *</span></label>
            } @else {
              <span class="col-lg-4 control-label static-label">Display Name<span class="orange-asterisk"> *</span></span>
            }
            <div class="col-lg-8">
              @if (!stickyPinned) {
                <input id="displayName" [readonly]="defaults.isDataAnalytStage()" class="form-control" formControlName="displayName" required>
              }
              @if (stickyPinned) {
                <p>{{userDetails.displayName}}</p>
              }
              <span class="field-validation-valid text-danger" data-valmsg-for="DisplayName" data-valmsg-replace="true"></span>
              @if (
                editUserForm.get('displayName')?.invalid &&
                (editUserForm.get('displayName')?.dirty ||
                editUserForm.get('displayName')?.touched)) {
                <p>
                  @if (editUserForm.get('displayName')?.hasError('required')) {
                    <mat-error>Display Name is required</mat-error>
                  }
                  @if (editUserForm.get('displayName')?.hasError('maxlength')) {
                    <mat-error>Max {{ limits.DisplayName }} characters</mat-error>
                  }
                </p>
              }
              @if (!(
                editUserForm.get('displayName')?.invalid &&
                (editUserForm.get('displayName')?.dirty ||
                editUserForm.get('displayName')?.touched))) {
                <p><br> </p>
              }
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-6 zoomIn">
            <label class="col-lg-4 control-label" for="firstName">First Name<span class="orange-asterisk"> *</span></label>
            <div class="col-lg-8">
              <input id="firstName" [readonly]="defaults.isDataAnalytStage()" class="form-control" formControlName="firstName" required>
              <span class="field-validation-valid text-danger" data-valmsg-for="firstName" data-valmsg-replace="true"></span>
              @if (
                editUserForm.get('firstName')?.invalid &&
                (editUserForm.get('firstName')?.dirty ||
                editUserForm.get('firstName')?.touched)) {
                <p>
                  @if (editUserForm.get('firstName')?.hasError('required')) {
                    <mat-error>First Name is required</mat-error>
                  }
                  @if (editUserForm.get('firstName')?.hasError('maxlength')) {
                    <mat-error>Max {{ limits.GivenName }} characters</mat-error>
                  }
                </p>
              }
              @if (!(
                editUserForm.get('firstName')?.invalid &&
                (editUserForm.get('firstName')?.dirty ||
                editUserForm.get('firstName')?.touched))) {
                <p><br> </p>
              }
            </div>
          </div>
          <div class="form-group col-lg-6 zoomIn">
            <label class="col-lg-4 control-label" for="lastName">Last Name<span class="orange-asterisk"> *</span></label>
            <div class="col-lg-8">
              <input id="lastName" [readonly]="defaults.isDataAnalytStage()" class="form-control" formControlName="lastName" required>
              <span class="field-validation-valid text-danger" data-valmsg-for="lastName" data-valmsg-replace="true"></span>
              @if (
                editUserForm.get('lastName')?.invalid &&
                (editUserForm.get('lastName')?.dirty ||
                editUserForm.get('lastName')?.touched)) {
                <p>
                  @if (editUserForm.get('lastName')?.hasError('required')) {
                    <mat-error>Last Name is required</mat-error>
                  }
                  @if (editUserForm.get('lastName')?.hasError('maxlength')) {
                    <mat-error>Max {{ limits.Surname }} characters</mat-error>
                  }
                </p>
              }
              @if (!(
                editUserForm.get('lastName')?.invalid &&
                (editUserForm.get('lastName')?.dirty ||
                editUserForm.get('lastName')?.touched))) {
                <p><br> </p>
              }
            </div>
          </div>
        </div>
        @if (!defaults.isDataAnalytStage()) {
          <div class="row">
            @if (defaults.componentTool === componentToolEnum.Mersy)
            {
              <div class="form-group col-lg-6 zoomIn">
                <label class="col-lg-4 control-label" for="locationSelect">
                  <span>Location</span><span class="orange-asterisk"> * </span>
                  <span class="glyphicon glyphicon-info-sign" data-toggle="tooltip" title="Country Code (following two characters ISO convention). This filter specifies user's location." aria-hidden="true"></span>
                </label>
                <div class="col-lg-8">
                  <ng-select labelForId="locationSelect"
                    (change)="onPrimTenChange($event)"
                    [items]="userDetails.locationSelectList"
                    [searchable]="true"
                    [clearable]="false"
                    class="tenantStyling required"
                    bindLabel="text"
                    bindValue="value"
                    formControlName="usageLocation"
                    [dropdownPosition]="'bottom'"
                    required>
                  </ng-select>
                </div>
              </div>
            }
            @else 
            {
              <div class="form-group col-lg-6 zoomIn">
                <label class="col-lg-4 control-label" for="primaryTenantSelect">
                  <span>Primary Tenant</span><span class="orange-asterisk"> * </span>
                  <span class="glyphicon glyphicon-info-sign" data-toggle="tooltip" title="Country Code (following two characters ISO convention). This filter specifies user's primary tenant." aria-hidden="true"></span>
                </label>
                <div class="col-lg-8">
                  <ng-select labelForId="primaryTenantSelect"
                    (change)="onPrimTenChange($event)"
                    [items]="userDetails.tenantsSelectList"
                    [searchable]="true"
                    [clearable]="false"
                    class="tenantStyling required"
                    bindLabel="text"
                    bindValue="value"
                    formControlName="tenant"
                    [dropdownPosition]="'bottom'"
                    required>
                  </ng-select>
                </div>
              </div>
            }
            <div class="form-group col-lg-6 zoomIn">
              <label class="col-lg-4 control-label" for="companyName">Company Name</label>
              <div class="col-lg-8">
                <input id="companyName" class="form-control" formControlName="companyName">
                <span class="field-validation-valid text-danger" data-valmsg-for="lastName" data-valmsg-replace="true"></span>
                @if (editUserForm.get('companyName')?.invalid &&
                  (editUserForm.get('companyName')?.dirty ||
                  editUserForm.get('companyName')?.touched)) {
                  <p>
                    @if (editUserForm.get('companyName')?.hasError('maxlength')) {
                      <mat-error>Max {{ limits.CompanyName }} characters</mat-error>
                    }
                  </p>
                }
                        <!--<p *ngIf="
                              editUserForm.get('companyName')?.invalid &&
                                (editUserForm.get('companyName')?.dirty ||
                                  editUserForm.get('companyName')?.touched)">
                <mat-error *ngIf="editUserForm.get('companyName')?.hasError('required')">Sponsor is required</mat-error>
              </p>
                    <p *ngIf="!(
                              editUserForm.get('sponsor')?.invalid &&
                                (editUserForm.get('sponsor')?.dirty ||
                                  editUserForm.get('sponsor')?.touched))"><br> </p>-->
              </div>
            </div>
            <!--<div class="form-group col-lg-6 " *ngIf="defaults.componentTool === componentToolEnum.Rulebook">-->
            @if (false) {
              <div class="form-group col-lg-6  zoomIn">
                <label class="col-lg-4 control-label">
                  Secondary Tenant
                  <span class="glyphicon glyphicon-info-sign" data-toggle="tooltip" title="Other tenants for which the user is part of." aria-hidden="true"></span>
                </label>
                <div class="col-lg-8">
                  <ng-select (change)="onSecTenChange()"
                    [matTooltip]="selectedSecTenString"
                    [matTooltipPosition]="'above'"
                    [items]="userDetails.secondaryTenantsSelectList"
                    groupBy="selectedAllGroup"
                    [selectableGroup]="true"
                    [selectableGroupAsModel]="false"
                    [searchable]="true"
                    [clearable]="true"
                    [closeOnSelect]="false"
                    [multiple]="true"
                    bindLabel="text"
                    bindValue="value"
                    formControlName="secondaryTenants"
                    (open)="onOpenScrollbar()"
                    [dropdownPosition]="'bottom'"
                    (add)="updateTenSet( { selTen:[$event.value], checked: true })"
                    (remove)="updateTenSet( { selTen:[$event.value], checked: false })">
                    <ng-template ng-optgroup-tmp>
                      Select All
                    </ng-template>
                    <ng-template ng-option-tmp
                      let-item="item">
                      {{ item.label }}
                    </ng-template>
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                      @if (this.editUserForm.controls['secondaryTenants'].value.length <= 2) {
                        <div class="items-selected">
                          @for (item of this.editUserForm.controls['secondaryTenants'].value; track item) {
                            <div class="ng-value">
                              <span class="ng-value-label">{{item.label}}</span>
                            </div>
                          }
                        </div>
                      }
                      @if (items.length > 2) {
                        <div class="ng-value">
                          <span class="ng-value-label">{{items.length}} Selected...</span>
                        </div>
                      }
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            }
          </div>
        }
        <br>
        @if (defaults.componentTool !== componentToolEnum.Mersy)
        {
          <div class="row">
            <div class="form-group col-lg-6 zoomIn">
                <label class="col-lg-4 control-label" for="locationSelect">
                    <span>Location</span><span class="orange-asterisk"> * </span>
                    <span class="glyphicon glyphicon-info-sign" data-toggle="tooltip" title="Country Code (following two characters ISO convention). This filter specifies user's primary location." aria-hidden="true"></span>
                </label>
                <div class="col-lg-8">
                    <ng-select labelForId="locationSelect"
                               (change)="onPrimTenChange($event)"
                               [items]="userDetails.locationSelectList"
                               [searchable]="true"
                               [clearable]="false"
                               class="tenantStyling required"
                               bindLabel="text"
                               bindValue="value"
                               formControlName="usageLocation"
                               [dropdownPosition]="'bottom'"
                               required>
                    </ng-select>
                </div>
            </div>
            @if (defaults.componentTool === componentToolEnum.Rulebook && (defaults.isMFGAdminCenterUser || defaults.isMFGAdminUser)) 
            {
              <div class="form-group col-lg-6 zoomIn">
                  <label class="col-lg-4 control-label" for="manufacturingCenterSelect">
                      Manufacturing Center
                  </label>
                  <div class="col-lg-8">
                      <ng-select labelForId="manufacturingCenterSelect"
                                 (change)="onMfgCenterChange()"
                                 [matTooltip]="selectedMfgCenterString"
                                 [matTooltipPosition]="'above'"
                                 [items]="availableCenters"
                                 groupBy="selectedAllGroup"
                                 [selectableGroup]="true"
                                 [selectableGroupAsModel]="false"
                                 [searchable]="true"
                                 [clearable]="true"
                                 [closeOnSelect]="false"
                                 [multiple]="true"
                                 bindLabel="centerName"
                                 bindValue="centerName"
                                 formControlName="manufacturingCenters"
                                 (open)="onOpenScrollbar()"
                                 [dropdownPosition]="'bottom'"
                                 (add)="updateMfgCenterSet( { selMfgCenter:[$event.value], checked: true })"
                                 (remove)="updateMfgCenterSet( { selMfgCenter:[$event.value], checked: false })">
                          <ng-template ng-optgroup-tmp>
                              Select All
                          </ng-template>
                          <ng-template ng-option-tmp
                                       let-item="item">
                              {{ item.centerName }}
                          </ng-template>
                          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                              @if (this.editUserForm.controls['manufacturingCenters'].value.length <= 2) {
                              <div class="items-selected">
                                  @for (item of this.editUserForm.controls['manufacturingCenters'].value; track item) {
                                  <div class="ng-value">
                                      <span class="ng-value-label">{{item}}</span>
                                  </div>
                                  }
                              </div>
                              }
                              @if (items.length > 2) {
                              <div class="ng-value">
                                  <span class="ng-value-label">{{items.length}} Selected...</span>
                              </div>
                              }
                          </ng-template>
                      </ng-select>
                  </div>
              </div>
            }
          </div>
        }
          <br>
          @if (defaults.componentTool === componentToolEnum.Rulebook && !defaults.isDataAnalytStage()) {
          <div class="row">
              <div class="form-group col-lg-6 zoomIn">
                  <p class="darkBackground">
                      <mat-checkbox formControlName="active" class="pl-2">
                          Active
                          <span class="glyphicon glyphicon-info-sign" data-toggle="tooltip" title="This flag will enable/disable the user in the AAD, so the user is not removed but it will not be able to login in any of the platforms." aria-hidden="true"></span>
                      </mat-checkbox>
                  </p>
              </div>
          </div>
          }
          @if (isProductionEnvironment === true && (defaults.isMersyAdminUser || defaults.isadminuser)) {
          <div class="row">
              <div class="form-group col-lg-6 zoomIn">
                  <p class="darkBackground">
                      <mat-checkbox formControlName="mersyAccessReportDev" class="pl-2" (change)="onMersyDirectClick($event,3)">
                          Mersy Direct-Report - Power BI - DEV
                          <span class="glyphicon glyphicon-info-sign" data-toggle="tooltip" title="Mark this flag if the user needs to gain access in CDP Mersy Direct-Report - Power BI for DEV." aria-hidden="true"></span>
                      </mat-checkbox>
                  </p>
              </div>
          </div>
          }
          @if (isProductionEnvironment === true && (defaults.isMersyAdminUser || defaults.isadminuser === true)) {
          <div class="row">
              <div class="form-group col-lg-6 zoomIn">
                  <p class="darkBackground">
                      <mat-checkbox formControlName="mersyAccessReport" class="pl-2" (change)="onMersyDirectClick($event,0)">
                          Mersy Direct-Report - Power BI
                          <span class="glyphicon glyphicon-info-sign" data-toggle="tooltip" title="Mark this flag if the user needs to gain access in CDP Mersy Direct-Report - Power BI." aria-hidden="true"></span>
                      </mat-checkbox>
                  </p>
              </div>
          </div>
          }
          @if (isProductionEnvironment === true && (defaults.isMersyAdminMarketQueryUser || defaults.isadminuser === true)) {
          <div class="row">
              <div class="form-group col-lg-6 zoomIn">
                  <p class="darkBackground">
                      <mat-checkbox formControlName="marketQueryAccessReport" class="pl-2" (change)="onMersyDirectClick($event,1)">
                          Market Query Direct Report - Power BI
                          <span class="glyphicon glyphicon-info-sign" data-toggle="tooltip" title="Mark this flag if the user needs to gain access in CDP Market Query Direct Report - Power BI." aria-hidden="true"></span>
                      </mat-checkbox>
                  </p>
              </div>
          </div>
          }
          @if (isProductionEnvironment === true && (defaults.isMersyNiOpsAdminUser || defaults.isadminuser === true)) {
          <div class="row">
              <div class="form-group col-lg-6 zoomIn">
                  <p class="darkBackground">
                      <mat-checkbox formControlName="eoxNiOpsAccessReport" class="pl-2" (change)="onMersyDirectClick($event,2)">
                          EOX NI Ops Direct Report - Power BI
                          <span class="glyphicon glyphicon-info-sign" data-toggle="tooltip" title="Mark this flag if the user needs to gain access in CDP EOX NI Ops Direct Report - Power BI." aria-hidden="true"></span>
                      </mat-checkbox>
                  </p>
              </div>
          </div>
          }
          <div class="panel-body row button-container stickyTopBtns zoomIn">
              <div class="left-buttons">
                  @if (defaults.isadminuser === true && defaults.componentTool === componentToolEnum.Rulebook && !defaults.isDataAnalytStage()) {
                  <button mat-raised-button (click)="handledelbutton($event)" class="btn button-fix button-color-fix-red ">
                      Delete
                      <mat-icon class=" icon-color-fix">delete</mat-icon>
                  </button>
                  }
                  @if (!defaults.isDataAnalytStage() && (editUserForm.get('isexternaluser')?.value === null ? false : !editUserForm.get('isexternaluser')?.value)) {
                  <button mat-raised-button (click)="handleresetbutton($event)" class="btn button-fix button-color-fix-orange">
                      Password
                      <mat-icon class=" icon-color-fix">lock</mat-icon>
                  </button>
                  }
                  @if (!defaults.isDataAnalytStage() || defaults.isadminuser ) {
                  <button mat-raised-button (click)="clearCacheUser($event)" class="btn button-fix button-color-fix-orange ">
                      Clear Cache
                      <mat-icon class=" icon-color-fix">delete_sweep</mat-icon>
                  </button>
                  }
                  @if (!defaults.isDataAnalytStage()) {
                  <button mat-raised-button (click)="getUserCache($event)" class="btn button-fix button-color-fix-orange ">
                      Check Cache
                      <mat-icon class=" icon-color-fix">open_in_new</mat-icon>
                  </button>
                  }
                  @if (defaults.userCanCheckUserHistory()) {
                  <button mat-raised-button (click)="checkUserHistory($event)" class="btn button-fix button-color-fix-grey">
                      Check User History
                      <mat-icon class=" icon-color-fix">open_in_new</mat-icon>
                  </button>
                  }
              </div>
              <!--<button mat-raised-button type="submit" class="btn right-buttons button-color-fix pull-right " [disabled]="(!editUserForm.valid || disableSaveButton)">
          Save
          <mat-icon class="icon-color-fix">save</mat-icon>
        </button>-->
            </div>
      </form>
      }

      <br />

      <!--User Special Permisssions Panel-->
      @if (defaults.isadminuser === true && defaults.componentTool === componentToolEnum.Rulebook && !defaults.isDataAnalytStage()) {
        <div class="panel-body zoomIn">
          <specialpermissions></specialpermissions>
        </div>
      }
      <!--User License Panel-->
      @if (!hideUserLicensesSection && defaults.componentTool === componentToolEnum.Rulebook && !defaults.isDataAnalytStage() &&
        ((defaults.isProdUserManagementPortalUser === true && defaults.stage === 1)
        || (defaults.isDevUserManagementPortalUser === true && defaults.stage === 0)
        || defaults.isadminuser)) {
        <div class="panel-body zoomIn">
          <userlicense></userlicense>
        </div>
      }

      <!--Azure DevOps Project Areas-->
      @if ((defaults.stage === 1 && defaults.isProdADOGroupUMPUser === true )
        || (defaults.stage === 0 && defaults.isDevADOGroupUMPUser === true ) && defaults.componentTool === componentToolEnum.Rulebook && !defaults.isDataAnalytStage()) {
        <div class="panel-body zoomIn">
          <azdevproj [groupmgmtcallback]="groupMgmtCallback"></azdevproj>
        </div>
      }

      <!--Max Roles Panel-->
      @if (defaults.componentTool === componentToolEnum.Rulebook && !defaults.isDataAnalytStage() &&
        (   (defaults.isProdUserManagementPortalUser === true && defaults.stage === 1)
        || (defaults.isDevUserManagementPortalUser === true && defaults.stage === 0)
        || defaults.isadminuser ) ) {
        <directindirectgeneric class="zoomIn" [componentName]="'Max Role'" [umpCategoryName]="'MaxRoles'"></directindirectgeneric>
      }

      @if (defaults.componentTool === componentToolEnum.Rulebook && !defaults.isDataAnalytStage() &&
        (defaults.isadminuser || defaults.isEMTManagerUser)) {
        <directindirectgeneric class="zoomIn" [componentName]="'Emt Role'" [umpCategoryName]="'EmtRoles'"></directindirectgeneric>
      }

      @if (defaults.componentTool === componentToolEnum.Rulebook && !defaults.isDataAnalytStage() &&
        ((defaults.isProdUserManagementPortalUser === true && defaults.stage === 1)
        || (defaults.isDevUserManagementPortalUser === true && defaults.stage === 0))
        && (defaults.isadminuser || defaults.isHomManagerUser)) {
        <directindirectgeneric class="zoomIn" [componentName]="'Home Role'" [umpCategoryName]="'HomeRoles'"></directindirectgeneric>
      }
      @if (defaults.componentTool === componentToolEnum.Rulebook && !defaults.isDataAnalytStage() &&
        defaults.isMfgManagerUser) {
        <directindirectgeneric class="zoomIn" [componentName]="'MFG Role'" [umpCategoryName]="'MfgRoles'"></directindirectgeneric>
        }  <!--defaults.isMfgManagerUser-->
        <!--C360 Groups-->
        @if (defaults.componentTool === componentToolEnum.Rulebook && !defaults.isDataAnalytStage() &&
          ((defaults.isProdUserManagementPortalUser === true && defaults.stage === 1)
          || (defaults.isDevUserManagementPortalUser === true && defaults.stage === 0))) {
          <directindirectgeneric class="zoomIn" [componentName]="'C360 Group'" [umpCategoryName]="'C360Groups'"></directindirectgeneric>
        }
        <!--Mersy Groups-->
        @if (!defaults.isDataAnalytStage() && ((defaults.stage === 1 && defaults.isProdMersyUMPUser === true )
          || (defaults.stage === 0 && defaults.isDevMersyUMPUser === true )
          || defaults.isMersyAdminUser
          || defaults.isMersyNiOpsAdminUser
          || defaults.isMersyCDPTaxAdmin
          || defaults.isMersyAdminSafetySystemExcellence
          || defaults.isMersyAdminINCO
          || defaults.isMersyAdminBranchExcellenceUser
          || defaults.isMersyAdminMarketQueryUser)) {
          <div class="panel-body zoomIn">
            <mersygroups [groupmgmtcallback]="groupMgmtCallback"
              [isMQRequest]="(defaults.isMersyAdminMarketQueryUser === true)"
              [isNiOpsRequest]="(defaults.isMersyNiOpsAdminUser === true)"
              [isTaxRequest]="(defaults.isMersyCDPTaxAdmin === true)"
              [isSafetySystemExcellenceRequest]="(defaults.isMersyAdminSafetySystemExcellence === true)"
              [isINCORequest]="(defaults.isMersyAdminINCO === true)"
              [isBranchExcellenceRequest]="(defaults.isMersyAdminBranchExcellenceUser === true)"
              [isMersyRequest]="(defaults.isMersyAdminUser === true)"
            [isAdminRequest]="defaults.isadminuser || (defaults.isMersyAdminUser && defaults.isMersyNiOpsAdminUser)"> </mersygroups>
          </div>
        }

        <!--Mersy Roles-->
        @if (!defaults.isDataAnalytStage() && ((defaults.stage === 1 && defaults.isProdMersyUMPUser === true )
          || (defaults.stage === 0 && defaults.isDevMersyUMPUser === true )
          || defaults.isMersyAdminUser )) {
          <div class="panel-body zoomIn">
            <mersyroles [groupmgmtcallback]="groupMgmtCallback"
              [isMQRequest]="false"
              [isBERequest]="false"
              [isNiOpsRequest]="false"
              [isTaxRequest]="false"
              [isSafetySystemExcellenceRequest]="false"
            [isINCORequest]="false"> </mersyroles>
          </div>
        }

        <!--Branch Excellence Roles-->

        @if (!defaults.isDataAnalytStage() && ((defaults.stage === 1 && defaults.isProdMersyUMPUser === true )
          || (defaults.stage === 0 && defaults.isDevMersyUMPUser === true )
          || defaults.isMersyAdminBranchExcellenceUser )) {
          <div class="panel-body zoomIn">
            <mersyroles [groupmgmtcallback]="groupMgmtCallback"
              [isMQRequest]="false"
              [isBERequest]="true"
              [isNiOpsRequest]="false"
              [isTaxRequest]="false"
              [isSafetySystemExcellenceRequest]="false"
            [isINCORequest]="false"> </mersyroles>
          </div>
        }

        <!--Market Query Roles-->

        @if (defaults.isMersyAdminMarketQueryUser) {
          <div class="panel-body zoomIn">
            <mersyroles [groupmgmtcallback]="groupMgmtCallback"
              [isMQRequest]="true"
              [isBERequest]="false"
              [isNiOpsRequest]="false"
              [isTaxRequest]="false"
              [isSafetySystemExcellenceRequest]="false"
            [isINCORequest]="false"> </mersyroles>
          </div>
        }
        @if (defaults.isMersyAdminMarketQueryUser) {
          <directindirectgeneric class="zoomIn" [componentName]="'Market Line Of Business'" [umpCategoryName]="'MarketLineOfBusiness'" [checkboxOptions]="{ useCheckbox: true, useSelectAll: true }" [disablePluralSuffix]="true"></directindirectgeneric>
        }

        @if (defaults.isMersyAdminMarketQueryUser) {
          <directindirectgeneric class="zoomIn" [componentName]="'Market Product Type'" [umpCategoryName]="'MarketProductType'" [checkboxOptions]="{ useCheckbox: true, useSelectAll: true }"></directindirectgeneric>
        }
        <!--EOX NiOps Roles-->

        @if (!defaults.isDataAnalytStage() && ((defaults.stage === 1 && defaults.isProdMersyUMPUser === true )
          || (defaults.stage === 0 && defaults.isDevMersyUMPUser === true )
          || defaults.isMersyNiOpsAdminUser )) {
          <div class="panel-body zoomIn">
            <mersyroles [groupmgmtcallback]="groupMgmtCallback"
              [isMQRequest]="false"
              [isBERequest]="false"
              [isNiOpsRequest]="true"
              [isTaxRequest]="false"
              [isSafetySystemExcellenceRequest]="false"
            [isINCORequest]="false"> </mersyroles>
          </div>
        }


        <!--TAX@CDP PE Reporting Roles-->
        @if (defaults.isMersyCDPTaxAdmin) {
          <div class="panel-body zoomIn">
            <mersyroles [groupmgmtcallback]="groupMgmtCallback"
              [isMQRequest]="false"
              [isBERequest]="false"
              [isNiOpsRequest]="false"
              [isTaxRequest]="true"
              [isSafetySystemExcellenceRequest]="false"
            [isINCORequest]="false"> </mersyroles>
          </div>
        }

        <!--Safety System Excellence Roles-->
        @if (defaults.isMersyAdminSafetySystemExcellence) {
          <div class="panel-body zoomIn">
            <mersyroles [groupmgmtcallback]="groupMgmtCallback"
              [isMQRequest]="false"
              [isBERequest]="false"
              [isNiOpsRequest]="false"
              [isTaxRequest]="false"
            [isSafetySystemExcellenceRequest]="true"> </mersyroles>
          </div>
        }

        <!--INCO Roles-->
        @if (defaults.isMersyAdminINCO) {
          <div class="panel-body zoomIn">
            <mersyroles [groupmgmtcallback]="groupMgmtCallback"
              [isMQRequest]="false"
              [isBERequest]="false"
              [isNiOpsRequest]="false"
              [isTaxRequest]="false"
              [isSafetySystemExcellenceRequest]="false"
            [isINCORequest]="true"> </mersyroles>
          </div>
        }

        <!--Data Analytics and PowerBI Workspaces Panel-->
        @if (isProductionEnvironment) {
          <div class="panel-body zoomIn">
            <daworkspace [groupmgmtcallback]="groupMgmtCallback"> </daworkspace>
          </div>
        }


        <!--Branch Hierarchy-->
        @if (defaults.componentTool === componentToolEnum.Rulebook && !defaults.isDataAnalytStage() &&
          ((defaults.isProdUserManagementPortalUser === true && defaults.stage === 1)
          || (defaults.isDevUserManagementPortalUser === true && defaults.stage === 0)
          || defaults.isEMTManagerUser === true
          || defaults.isMfgManagerUser ===true )) {
          <div class="panel-body zoomIn">
            <umpbranchhierarchy (secondaryTenUpdate)="updateTenSet($event)"
              (mgmtIdUpdate)="onMgmtIdUpdate($event)"
              [reload]="reload"
            [groupmgmtcallback]="groupMgmtCallback"> </umpbranchhierarchy>
          </div>
        }

        <!--Management Branch Hierarchy-->
        @if (!defaults.isDataAnalytStage() && ((defaults.stage === 1 && defaults.isProdMersyUMPUser === true )
          || (defaults.stage === 0 && defaults.isDevMersyUMPUser === true )
          || defaults.isMersyAdminUser
          || defaults.isMersyAdminMarketQueryUser
          || defaults.isMersyAdminBranchExcellenceUser
          || defaults.isMersyNiOpsAdminUser
          || defaults.isMersyCDPTaxAdmin
          || defaults.isMersyAdminSafetySystemExcellence
          || defaults.isMersyAdminINCO)) {
          <div class="panel-body zoomIn custom-license-checkbox-scope">
            <usermgmtbranch [groupmgmtcallback]="groupMgmtCallback"> </usermgmtbranch>
          </div>
        }

        <!-- MERSY KPI Group Function - Hidden for MERSY users -->
        @if (defaults.componentTool !== componentToolEnum.Mersy) {
          <div class="panel-body zoomIn">
            <mersykpigroupfunction [groupmgmtcallback]="groupMgmtCallback"></mersykpigroupfunction>
          </div>
        }

        <!--CDP Hierarchy-->
        @if (!defaults.isDataAnalytStage()
          && defaults.stage === 1
          && defaults.isProdMersyUMPUser) {
          <div class="panel-body zoomIn">
            <cdphierarchy [groupmgmtcallback]="groupMgmtCallback"> </cdphierarchy>
          </div>
        }

      </div>

    </div>


    <div class="stickypanel">

      <button mat-raised-button routerLink="/UmpHome" (click)="onBack()" type="submit" class="btn button-fix button-color-fix-red ">
        <mat-icon class=" icon-color-fix ">arrow_back_ios</mat-icon>
        Back
      </button>
      <button mat-raised-button (click)="saveService.fireSave()" type="submit" class="btn button-fix button-color-fix-orange" [disabled]="(saveService.listeners.length === 0 && disableSaveButton) || (disableSaveButton === false && !editUserForm.valid)">
        <mat-icon class="icon-color-fix">save</mat-icon>
        Save
      </button>
    </div>

